<div class="wrapper">
  <div class="dialog-title" mat-dialog-title>
    <div
      class="product-best-value"
      [class.product-best-value-background]="isBestValue"
      [class]="platform + '-background'"
    >
      {{ isBestValue ? (bestValueTranslation | translate) : '' }}
    </div>
    <div class="product-details-header">
      <span class="title-s">{{ product.name | translate }}</span>
      <mat-icon mkpDataTest="benefits-close" (click)="close(false)">close</mat-icon>
    </div>
  </div>

  <section mat-dialog-content>
    <div class="content-wrapper">
      <div class="calendar-feature-wrapper">
        @if (calendarFeature) {
          <ui-product-calendar-label
            [productCode]="product.code"
            [title]="calendarFeature.translation"
          />
        }
        @if (calendarFeature?.description) {
          <ui-product-tooltip [text]="calendarFeature.description" />
        }
      </div>
      <hr />
      @if (platformMapping?.length) {
        <div class="platforms-wrapper">
          <span class="body-s semibold title">{{ 'PRODUCT_OFFERING.PLATFORMS' | translate }}</span>
          @for (platform of platformMapping; track platform.id) {
            <div class="platform">
              <ui-product-platform-cell [platform]="platform.id" />
              <span
                class="body-s platform-description description"
                [innerHtml]="platform.description | translate"
              ></span>
            </div>
          }
        </div>
      }
      @if (benefitMapping?.length) {
        <div class="benefits-wrapper">
          <span class="body-s semibold title">{{ 'PRODUCT_OFFERING.BENEFITS' | translate }}</span>
          @for (benefit of benefitMapping; track benefit.id) {
            <div class="benefit">
              <span class="body-default bold benefit-title">
                {{ benefit.title | translate }}
                @if (benefit.id | benefitFlag; as flag) {
                  <ui-asset [name]="flag" set="flags" />
                }
              </span>
              <span class="body-s description">{{ benefit.description | translate }}</span>
            </div>
          }
        </div>
      }

      @if (product.code === ProductCode.JOBSOFFER22XS || product.code === ProductCode.JOBUP24LITE) {
        <div class="subcategories-wrapper">
          <hr />
          <div class="title-xxs title-benefits-m-b">
            @if (product.code === ProductCode.JOBSOFFER22XS) {
              {{ 'PRODUCT_OFFERING.JOBS.LITE_PRODUCT.SUBCATEGORIES.HEADING' | translate }}
            } @else {
              {{ 'PRODUCT_OFFERING.JOBUP.LITE_PRODUCT.ITEMS.HEADING' | translate }}
            }
          </div>
          @if (product.code === ProductCode.JOBSOFFER22XS) {
            @for (category of LITE_PRODUCT_AVAILABLE_SUBCATEGORIES; track category.name) {
              <div class="sub-category">
                <span class="body-default bold">{{ category.name | translate }}</span>
                <ul>
                  @for (item of category.items; track item) {
                    <li>
                      {{ item | translate }}
                    </li>
                  }
                </ul>
              </div>
            }
          } @else {
            <div class="sub-category">
              <ul>
                @for (item of JOBUP_LITE_PRODUCT_AVAILABLE_ITEMS; track item) {
                  <li>
                    {{ item | translate }}
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
    </div>
  </section>
  @if (!isReadMode) {
    <section mat-dialog-actions>
      <ui-button
        class="action-btn"
        mkpDataTest="select-cta-detailed-view-btn"
        [config]="selectConfig"
        (click)="close(true)"
      >
        {{ 'PRODUCT_OFFERING.SELECT_PLAN' | translate }}
      </ui-button>
    </section>
  }
</div>
